module.exports = __webpack_public_path__ + "static/media/halan-3837.6015b502.jpg";